import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import {cekCookies} from '../../../../actions';
import accountManagement from '../../../../apis/accountManagement';
import { CONFIG } from '../../../../config';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import { Alert } from 'react-bootstrap';
import {Button, ButtonGroup} from '@material-ui/core';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import JadwalForm from './JadwalForm';
import JadwalMapelForm from './JadwalMapelForm';
import KelasParalelSearch from '../../../../entity/KelasParalelSearch';

class JadwalExam extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            error: null,
            listProfil: [],
            listJadwal: [],
            profil: {},
            jadwal: {},
            resMessage: '',
            isFetching: false,
            isSearch: false,
            addJadwal:false,
            addJadwalSub:false,
            alertShow: false,
            openDialog: false,  
            anchorEl: null,          
        }
    }
    async componentDidMount() { 
        document.title = "Jadwal Exam";
        this.setState({ isFetching: true});
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)) {
            this.fetchExam();
        } 
        this.setState({ isFetching: false});  
        
        window.$("#sidebar").mCustomScrollbar({
            theme: "minimal"
            });
            window.$('#sidebarCollapse').on('click', function () {
            window.$('#sidebar, #content').toggleClass('active');
            window.$('.collapse.in').toggleClass('in');
            window.$('a[aria-expanded=true]').attr('aria-expanded', 'false');
        }); 
    }

    fetchExam = async() => {   
        this.setState({isSearch:true})     
        const resExam = await accountManagement.get(CONFIG.EXAM_JADWAL_LIST + this.props.account.idSekolah)
        .catch(function(error){
            //this.setState({error});
        });
        if(resExam){
            if(resExam.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    listProfil: resExam.data.data.profils,
                    listJadwal: resExam.data.data.jadwals,
                })
            }
            this.setState({isSearch:false})
        }        
    }    
    
    addJadwal(profil) {
        this.setState({ 
            addJadwal: true,
            alertShow: false, 
            profil: {...profil,
                 ['idSekolah']: this.props.account.idSekolah,
                 ['idAdmin']: this.props.account.idAdmin
            },
            jadwal: {}
        });
    }

    editJadwal = async(profil, id) => {  
        this.setState({ isFetching: true, anchorEl: false});
        const result = await accountManagement.get(CONFIG.EXAM_GET_JADWAL_BY_ID + id)
            .catch(function(error){ alert(error)  });
        
        if (result) {  
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){             
                this.setState({ 
                    addJadwal: true,
                    alertShow: false, 
                    jadwal: result.data.data,
                    profil: {...profil,
                        ['idSekolah']: this.props.account.idSekolah,
                        ['idAdmin']: this.props.account.idAdmin
                    }
                });
            } 
            this.setState({ isFetching: false });           
        } 
             
    }   
    
    deleteJadwal = async(id) => {
        this.setState({isFetching: true, openDialog:false })
        const response = await accountManagement.post(CONFIG.EXAM_JADWAL_DELETE + id)
        .catch(function(error){ alert(error) });
        const {listJadwal} = this.state;
        if(response) {    
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){   
                this.setState({ 
                    listJadwal: listJadwal.filter(jadwal => jadwal.idJadwal !== id),                
                });                
            }
            this.setState({                
                resMessage: response.data.errorSchema.errorMessage,                
                isFetching: false,
                alertShow: true
            })            
        }
    }

    showDialog = (jadwal) => {        
        this.setState({
            anchorEl: false,
            openDialog: true,
            jadwal: jadwal            
        })
    }

    confirmDialog() {
        const {openDialog, jadwal} = this.state;        
        const handleClose = () => { this.setState({openDialog: false}) };        
        return (
            <>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Konfirmasi Hapus?"}</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Menghapus Jadwal juga akan menghapus report Siswa<br/>
                    Yakin akan menghapus <strong>{jadwal.namaJadwal}</strong> ?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    <button className="btn btn-primary" onClick={() => this.deleteJadwal(jadwal.idJadwal)} autoFocus> Ya </button>                    
                </DialogActions>
            </Dialog>
            </>
        )
    }

    submitJadwal = async(dataSend) => {
        this.setState({isFetching: true })
        const response = await accountManagement.post(CONFIG.EXAM_JADWAL_SAVE, dataSend)
        .catch(function(error){
            //this.setState({error});
        });
        const {listJadwal} = this.state;
        if(response) {    
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){   
                this.setState({ 
                    listJadwal: listJadwal.filter(jadwal => jadwal.idJadwal != dataSend.idJadwal),                
                });
                this.setState(prevState => ({
                    listJadwal: [...prevState.listJadwal, response.data.data]
                })); 
                this.setState({addJadwal: false})  
                document.getElementById('col-parent-'+ response.data.data.idProfil).classList.add('show');
            }
            this.setState({                
                resMessage: response.data.errorSchema.errorMessage,                
                isFetching: false,
                alertShow: true
            })            
        }
    }

    submitJadwalSub = async(dataSend, idProfil) => {
        this.setState({isFetching: true })
        const response = await accountManagement.post(CONFIG.EXAM_JADWAL_SUB_SAVE, dataSend)
        .catch(function(error){
            alert(error)
        });
       
        if(response) {    
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){  
                this.setState({addJadwalSub: false})  
                document.getElementById('col-parent-'+ idProfil).classList.add('show');
            }
            this.setState({                
                resMessage: response.data.errorSchema.errorMessage,                
                isFetching: false,
                alertShow: true
            })            
        }
    }

    handleBack = (value) => {        
        this.setState({ 
            addJadwal: false ,
            addJadwalSub: false           
        }); 
        //document.getElementById('col-parent-'+ value).classList.add('show');
    }

    addJadwalSub(jadwal) {
        this.setState({ 
            anchorEl: false,
            addJadwalSub: true,
            addJadwal: false,
            alertShow: false,
            jadwal: jadwal
        });
    }

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    render() {  
        const {error, listProfil, listJadwal, addJadwal, addJadwalSub, anchorEl} = this.state;        
        let formJadwal, formJadwalSub, title;        
        if(addJadwal) {
            formJadwal = <JadwalForm submitJadwal={this.submitJadwal} jadwal={this.state.jadwal} profil={this.state.profil} handleBack={this.handleBack} />
        }
        else if(addJadwalSub) {
            formJadwalSub = <JadwalMapelForm submitJadwalSub={this.submitJadwalSub} handleBack={this.handleBack}
                idJadwal={this.state.jadwal.idJadwal} idProfil={this.state.jadwal.idProfil} />
        }
        else {
            title = 'Management Jadwal Exam';
        }
         
        if(error){
            return (
                <div>Error: {error.message}</div>
              )
        } else {
            return ( 
                <div className="wrapper">
                    <Sidebar account={this.props.account}/>
                    <div id="content" style={{paddingBottom: '50px'}}>
                        <Navbar /> 
                        <div className="container-fluid"> 
                            {this.loadAlert()} 
                            <h4>{title}</h4>               
                            {this.loading()}   
                            {!(formJadwal || formJadwalSub) &&
                            <div id="accordion">      
                                {listProfil.map((profil, index) =>
                                <div className="card" style={{marginBottom: '5px'}} key={profil.idProfilCbt}>
                                    <div className="card-header">                    
                                        <div className="row">
                                            <div className="col-sm-5 col-xs-5">                        
                                                <a className="card-link" data-toggle="collapse" href={'#col-parent-' + profil.idProfilCbt}>
                                                {index + 1}. {profil.namaProfil} <i className="fa fa-angle-down" aria-hidden="true"></i>
                                                </a>                                    
                                            </div>

                                            <div className="col-sm-4 col-xs-4">
                                                {profil.namaKelas}
                                            </div>

                                            <div className="col-sm-1 col-xs-1">
                                                {profil.kodeSubTipeCbt}
                                            </div>

                                            <div className="col-sm-2 col-xs-2">
                                                <div className="button-group pull-right">                                        
                                                    <button className="btn btn-outline-primary btn-sm" onClick={() => this.addJadwal(profil)}>
                                                        <i className="fa fa-calendar-o" aria-hidden="true"></i> Add Jadwal</button>&nbsp;									
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div id={'col-parent-' + profil.idProfilCbt} className="collapse" data-parent="#accordion">
                                        <table className="table table-hover">
                                            <thead>                                
                                                <th>Judul</th>
                                                <th>Tgl Ujian</th>
                                                <th>Tgl Report &amp; Pembahasan</th>
                                                <th>#</th>
                                            </thead>
                                            <tbody>
                                                {listJadwal.map(jadwal =>                             
                                                    (jadwal.idProfil === profil.idProfilCbt ?                                        
                                                    <tr >    
                                                        <td>{jadwal.namaJadwal}</td>
                                                        <td>{jadwal.jadwalMulai} <small>s/d</small> {jadwal.jadwalSelesai}</td>
                                                        <td>{jadwal.jadwalReport}</td>
                                                        <td>
                                                            
                                                            {/* <div className="btn-group" style={{width:'100%'}}>
                                                                <button className="btn btn-outline-dark dropdown-toggle" data-toggle="dropdown">
                                                                    Manage
                                                                </button>
                                                                <div className="dropdown-menu">
                                                                    <button className="btn dropdown-item" onClick={() => this.addJadwalSub(jadwal)}>Jadwal Mapel</button>
                                                                    <div className="dropdown-divider"></div>
                                                                    <button className="btn dropdown-item" onClick={() => this.editJadwal(profil, jadwal.idJadwal)}>Edit</button>
                                                                    <div className="dropdown-divider"></div>
                                                                    <button className="btn dropdown-item" onClick={() => this.showDialog(jadwal)}>Hapus</button>
                                                                </div>
                                                            </div> */}
                                                            <ButtonGroup variant="text" color="primary" aria-label="text primary button group">
                                                                <Button onClick={() => this.addJadwalSub(jadwal)} title="Jadwal Mapel"><EventAvailableIcon /></Button>
                                                                <Button onClick={() => this.editJadwal(profil, jadwal.idJadwal)} title="Edit"><CreateIcon /></Button>
                                                                <Button onClick={() => this.showDialog(jadwal)} title="Hapus"><DeleteForeverIcon /></Button>
                                                            </ButtonGroup>
                                                            
                                                        </td>
                                                    </tr>                         
                                                    :
                                                    <div></div> )                                    
                                                )}  
                                            </tbody>                        
                                        </table>                      
                                    </div>
                                </div>
                                )}
                            </div> }
                            {formJadwal}  
                            {formJadwalSub}  
                        </div>  
                    </div>
                    <LoaderModal isFetching={this.state.isFetching}/> 
                    {this.confirmDialog()}
                      
                </div>
            );
        }
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(JadwalExam); 